/* French money order for theme-rendered prices.
 *
 * Shopify prints the shop-currency template (${{amount}}) only for the primary
 * market; every other market gets that currency's built-in format, and for EUR
 * that is "€34,95" — symbol first. There is no setting for it: the shop
 * currency-formatting dialog only edits USD, and the France market exposes no
 * formatting control. Checkout already prints "34,95 €" on its own, so the only
 * places left out of step are the theme-rendered ones (cart, search).
 *
 * So: rewrite them here. Prices the LUMÉRA page hardcodes are already written
 * "34,95 €" and carry no leading symbol, so they never match.
 */
(function () {
  var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
  if (cur !== 'EUR') return;

  var NUM = '[0-9][0-9\\s\\u00a0\\u202f.,]*[0-9]|[0-9]';
  var WITH_CODE = new RegExp('€\\s*(' + NUM + ')\\s*EUR', 'g');
  var PLAIN     = new RegExp('€\\s*(' + NUM + ')', 'g');

  function fix(s) {
    return s.replace(WITH_CODE, '$1 €').replace(PLAIN, '$1 €');
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };
  var running = false;

  function sweep(root) {
    if (running) return;
    running = true;
    try {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (!n.nodeValue || n.nodeValue.indexOf('€') === -1) return NodeFilter.FILTER_REJECT;
          if (n.parentNode && SKIP[n.parentNode.nodeName]) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var n, hits = [];
      while ((n = walker.nextNode())) hits.push(n);
      for (var i = 0; i < hits.length; i++) {
        var out = fix(hits[i].nodeValue);
        if (out !== hits[i].nodeValue) hits[i].nodeValue = out;
      }
    } finally {
      running = false;
    }
  }

  function start() {
    sweep(document.body);
    // Horizon re-renders the cart in place on quantity change, so keep watching.
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && !running) { sweep(t.nodeType === 1 ? t : t.parentNode || document.body); }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
